import { apiList, $axios } from "@/api"

export default {
    actions: {
        getGlossaryEntries(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.glossary.getEntries.method,
                    params: {
                        wsfunction: apiList.glossary.getEntries.moodle_method,
                        letter: payload.letter,
                        id: payload.id,
                        limit: payload.limit,
                        from: payload.from
                    },
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getGlossaryCats(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.glossary.getGlossaryCats.method,
                    params: {
                        wsfunction: apiList.glossary.getGlossaryCats.moodle_method,
                        id: payload
                    },
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        triggerGlossaryViewEvent(_,payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.glossary.triggerViewEvent.method,
                    params: {
                        wsfunction: apiList.glossary.triggerViewEvent.moodle_method,
                    },
                    data: {
                        id: payload,
                        mode: 'student'
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        findGlossaryEntries(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.glossary.findGlossaryEntries.method,
                    params: {
                        wsfunction: apiList.glossary.findGlossaryEntries.moodle_method,
                    },
                    data: {
                        id: payload.id,
                        query: payload.query
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        }
    }
}
